module.exports = __webpack_public_path__ + "media/images/official/person03-ae24a0f516dee6e2b8e500648ce6ae65.svg";